import {
  fetchGet,
  fetchPost,
} from "../../content_panel/services/serviceClient";

export type WorkflowEntityType = "SO" | "ST" | "PO";
export type WorkflowEventType =
  | "entity_created"
  | "status_changed"
  | "doc_uploaded"
  | "doc_generated"
  | "dispute_raised"
  | "dispute_resolved"
  | "po_amended";
export type WorkflowStatusStream = "outward" | "inward";
export type WorkflowDocType = "invoice" | "eway" | "dc";

export interface WorkflowEntityCreatedContext {
  amount: number;
  material_type?: "FG" | "RM";
  st_subtype?: string;
  is_internal?: boolean;
  initial_status: string;
  required_docs: WorkflowDocType[];
  optional_docs: WorkflowDocType[];
  planned_stages?: string[];
  revision_of?: { inward_order_id: string; version: string };
}

export interface WorkflowDisputeEventContext {
  reason?: string;
  inventory_item_code?: string;
  item_name?: string;
  item_count?: number;
}

export interface WorkflowPOAmendedContext {
  to_inward_order_id: string;
  to_version: string;
  from_version: string;
}

export interface WorkflowStatusChangedContext {
  prev_status: string;
  new_status: string;
  remark?: string;
}

export const markInsufficientInventory = async (
  outwardId: string,
  remark: string,
): Promise<{ success: boolean; error?: string; flagged_at?: string }> => {
  const { fetchPost } =
    await import("../../content_panel/services/serviceClient");
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/mark-insufficient-inventory/${encodeURIComponent(
    outwardId,
  )}`;
  return fetchPost(url, { remark });
};

export interface WorkflowDocEventContext {
  doc_type: WorkflowDocType;
  is_mandatory: boolean;
  file_url?: string;
}

export interface WorkflowEvent {
  _id?: string;
  entity_type: WorkflowEntityType;
  entity_id: string;
  event_type: WorkflowEventType;
  status_stream: WorkflowStatusStream;
  context:
    | WorkflowEntityCreatedContext
    | WorkflowStatusChangedContext
    | WorkflowDocEventContext
    | WorkflowDisputeEventContext
    | WorkflowPOAmendedContext;
  created_by: string;
  created_by_name: string;
  created_at: string;
}

export const getWorkflowTimeline = async (
  entityId: string,
): Promise<{ success: boolean; data?: WorkflowEvent[]; error?: string }> => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/workflow/timeline/${encodeURIComponent(
    entityId,
  )}`;
  return fetchGet(url);
};

export const getWorkflowTimelinesBatch = async (
  entityIds: string[],
): Promise<{
  success: boolean;
  data?: Record<string, WorkflowEvent[]>;
  error?: string;
}> => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/workflow/timeline/batch`;
  return fetchPost(url, { entity_ids: entityIds });
};
